import { useDispatch } from 'react-redux'
import { useCallback } from 'react'
import { useBranchOfficeMemberRemoveDialog } from '../../../hooks/useDialog'
import { CompanyActions } from '../../../store/company'
import Dialog from '../../atoms/feedback/Dialog'
import { FlexColumn, FlexRow } from '../../atoms/layout/Flex'
import Button from '../../atoms/inputs/Button'
import Label from '../../atoms/display/Label'

export default function BranchOfficeMemberRemoveDialog() {
  const { state, close } = useBranchOfficeMemberRemoveDialog()
  const dispatch = useDispatch()

  const handleDelete = useCallback(() => {
    if (state?.branchOffice) {
      dispatch(
        CompanyActions.removeBranchOfficeMember({ branchOfficeId: state.branchOffice.id, userId: state.user.id })
      )
    }
  }, [dispatch, state?.branchOffice, state?.user.id])

  return (
    <Dialog
      open={state !== undefined}
      onClose={close}
      title="メンバーを外す"
      actions={
        <FlexRow>
          <Button color="caution" onClick={handleDelete}>
            外す
          </Button>
        </FlexRow>
      }
    >
      <FlexColumn>
        <FlexRow>
          <FlexRow width={80}>
            <Label text="支店名" />
          </FlexRow>
          <Label text={state?.branchOffice.name ?? ''} />
        </FlexRow>
        <FlexRow>
          <FlexRow width={80}>
            <Label text="ユーザー名" />
          </FlexRow>
          <Label text={state?.user.name ?? ''} />
        </FlexRow>
        <Label text="このユーザーをメンバーから外しますか？" />
      </FlexColumn>
    </Dialog>
  )
}
